export default __webpack_public_path__ + "static/media/ISWEC-4.0363aaaa.pdf";